/**
 * 加载旋转器组件
 * 提供统一的加载状态展示
 */

import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
  color?: 'primary' | 'secondary' | 'white';
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  className = '',
  color = 'primary'
}) => {
  const { t } = useTranslation();
  const sizeClasses = {
    small: 'h-4 w-4',
    medium: 'h-6 w-6',
    large: 'h-8 w-8'
  };

  const colorClasses = {
    primary: 'text-primary-600',
    secondary: 'text-secondary',
    white: 'text-white'
  };

  return (
    <div className={clsx('inline-block animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]', sizeClasses[size], colorClasses[color], className)} role="status">
      <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
        {t('app.loading')}
      </span>
    </div>
  );
};

export default LoadingSpinner;